import { RouteNames } from "../types/names";
import type { AppRouteRecordRaw } from "../types/types";

import { PERMISSIONS } from "@/shared/permissions";

const catalogRoutes: AppRouteRecordRaw[] = [
  {
    path: "/catalog",
    name: RouteNames.CATALOG,
    redirect: "/catalog/brands",
    meta: {
      showInMenu: false,
    },
  },
  {
    path: "/catalog/brands",
    name: RouteNames.BRANDS,
    component: () => import("@/pages/BrandsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Brands",
      menuTitle: "Brands",
      menuIcon: "lucide:tag",
      menuOrder: 5,
      showInMenu: true,
      menuGroup: "Catalog",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
    },
  },
  {
    path: "/catalog/brands/:id",
    name: RouteNames.BRAND_DETAIL,
    component: () => import("@/pages/BrandDetailPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Brand Detail",
      showInMenu: false,
    },
  },
  {
    path: "/catalog/attributes",
    name: RouteNames.ATTRIBUTES,
    component: () => import("@/pages/AttributesPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Attributes",
      menuTitle: "Attributes",
      menuIcon: "lucide:sliders-horizontal",
      menuOrder: 6,
      showInMenu: true,
      menuGroup: "Catalog",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
    },
  },
  {
    path: "/catalog/products",
    name: RouteNames.PRODUCTS,
    component: () => import("@/pages/ProductsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Products",
      menuTitle: "Products",
      menuIcon: "lucide:package",
      menuOrder: 7,
      showInMenu: true,
      menuGroup: "Catalog",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
    },
  },
  {
    path: "/catalog/collections",
    name: RouteNames.COLLECTIONS,
    component: () => import("@/pages/CollectionsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Collections",
      menuTitle: "Collections",
      menuIcon: "lucide:bookmark",
      menuOrder: 8,
      showInMenu: true,
      menuGroup: "Catalog",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
    },
  },
  {
    path: "/catalog/collections/:id",
    name: RouteNames.COLLECTION_DETAIL,
    component: () => import("@/pages/CollectionDetailPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Collection Detail",
      showInMenu: false,
    },
  },
  {
    path: "/catalog/assets",
    name: RouteNames.MEDIA_ASSETS,
    component: () => import("@/pages/MediaAssetsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Assets",
      menuTitle: "Assets",
      menuIcon: "lucide:image",
      menuOrder: 9,
      showInMenu: true,
      menuGroup: "Catalog",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
    },
  },
  {
    path: "/catalog/products/:id",
    name: RouteNames.PRODUCT_DETAIL,
    component: () => import("@/pages/ProductDetailPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_READ],
      title: "Product Detail",
      showInMenu: false,
    },
  },
  {
    path: "/catalog/imported-view",
    name: RouteNames.IMPORTED_VIEW,
    redirect: "/catalog/imported-view/imports",
    meta: {
      permissions: [PERMISSIONS.CATALOG_ADMIN],
      showInMenu: false,
    },
  },
  {
    path: "/catalog/imported-view/imports",
    name: RouteNames.IMPORTS,
    component: () => import("@/pages/ImportsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_ADMIN],
      title: "Imports",
      menuTitle: "Imports",
      menuIcon: "lucide:download",
      menuOrder: 11,
      showInMenu: true,
      menuGroup: "Catalog/Imported View",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
      menuGroupMeta: {
        "Imported View": { icon: "lucide:arrow-down-up", order: 10 },
      },
    },
  },
  {
    path: "/catalog/imported-view/exports",
    name: RouteNames.EXPORTS,
    component: () => import("@/pages/ExportsPage.vue"),
    meta: {
      permissions: [PERMISSIONS.CATALOG_ADMIN],
      title: "Exports",
      menuTitle: "Exports",
      menuIcon: "lucide:upload",
      menuOrder: 12,
      showInMenu: true,
      menuGroup: "Catalog/Imported View",
      menuGroupIcon: "lucide:layers",
      menuGroupOrder: 30,
      menuGroupMeta: {
        "Imported View": { icon: "lucide:arrow-down-up", order: 10 },
      },
    },
  },
];

export default catalogRoutes;
